// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_avatar__1a0Sl"};